module.exports = __webpack_public_path__ + "img/add-doc.eb60ab97.svg";